import script from "./ForgotPasswordNotify.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordNotify.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordNotify.vue?vue&type=style&index=0&id=82827e62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82827e62"]])

export default __exports__